import React from "react";
import "./AppDevelopment.css";

const AppDevelopment = () => {
  return (
    <div>
      <p>this is AppDevelopment</p>
      <p>this is AppDevelopment</p>
      <p>this is AppDevelopment</p>
      <p>this is AppDevelopment</p>
      <p>this is AppDevelopment</p>
      <p>this is AppDevelopment</p>
      <p>this is AppDevelopment</p>
      <p>this is AppDevelopment</p>
    </div>
  );
};

export default AppDevelopment;
